import React from 'react';
import PropTypes from 'prop-types';

import './input.style.scss';

const Input = ({ defaultStyle, disabled, name, required, type, value, onChange, color, placeholder }) => (
  <input
    onChange={e => onChange(e.target.value)}
    value={value}
    className={`customInput ${defaultStyle}`}
    disabled={disabled}
    name={name}
    id={name}
    required={required}
    type={type}
    style={{ borderColor: color }}
    placeholder={placeholder}
    aria-label={name}
  />
);

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultStyle: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  color: PropTypes.string,
  placeholder: PropTypes.string,
};

Input.defaultProps = {
  defaultStyle: '',
  disabled: false,
  name: '',
  required: false,
  type: 'text',
  color: '',
  placeholder: '',
};

export default Input;
